var _excluded = ["aria-labelledby", "aria-describedby", "variant", "children", "className", "dismissible", "isActive", "onDismiss", "onToggle", "alertMessages", "toggleExpand", "size", "title", "inlineChildren", "utils"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import nodeOfType from '../../utilities/types-of-node';
import Icon from '../icon';
import Type from '../type';
import StyledAlertBtnContainer from './styles/alert.button-container.styles';
import StyledAlertBody from './components/alert-body/alert.body.styles';
import StyledAlertIcon from './styles/alert.icon.styles';
import StyledAlert from './alert.styles';
import StyledAlertButton from './styles/alert.button.styles';
import StyledAlertChildren from './styles/alert.children.styles';
import StyledAlertBodyWrapper from './styles/alert.wrapper.styles';
import { AlertBody } from './components';
import InverseContext from '../../utilities/inverse-context';
import withDeprecatedProps from '../../utilities/with-deprecated-props/withDeprecatedProps';
var alertPropTypes = {
  /** Specifies a label / element to provide an accessible name for the Alerts Icon. */
  'aria-labelledby': PropTypes.string,
  /**
   * @deprecated since 2.56.0
   * @see aria-labelledby
   */
  ariaLabelledby: PropTypes.string,
  /** Specifies elements that provide a description for the Alerts Icon. */
  'aria-describedby': PropTypes.string,
  /**
   * @deprecated since 2.56.0
   * @see aria-describedby
   */
  ariaDescribedby: PropTypes.string,
  /** Specifies the variant of alert to inject the correct style. */
  variant: PropTypes.oneOf(['critical', 'caution', 'success', 'information', 'neutral']),
  /** Add custom CSS classes to component. */
  className: PropTypes.string,
  /** Alert Content */
  children: PropTypes.node,
  /** Manage the visibility state of the Alert by passing a bool to this prop. */
  isActive: PropTypes.bool,
  /** A callback function which is called after the Alert is dismissed. */
  onDismiss: PropTypes.func,
  /** A list of alerts. Used for alerts with collapsible content. */
  alertMessages: PropTypes.array,
  /** Adds a close button and hides the Alert onClick(). */
  dismissible: PropTypes.bool,
  /** Manage the expanded state of the Alert by passing a bool to this prop. */
  toggleExpand: PropTypes.bool,
  /** A callback function which is called after the Alert is toggled. */
  onToggle: PropTypes.func,
  /** Making the Alert message with md/lg/sm text and icon */
  size: PropTypes.oneOf(['lg', 'sm', 'md']),
  /** Alert Title */
  title: PropTypes.oneOfType([PropTypes.string, nodeOfType([Type])]),
  /** Putting the children body copy inline with the title. */
  inlineChildren: PropTypes.bool,
  /** Add utility props for styling */
  utils: PropTypes.object
};
var alertDefaultProps = {
  'aria-labelledby': null,
  ariaLabelledby: null,
  'aria-describedby': null,
  ariaDescribedby: null,
  alertMessages: [],
  variant: 'neutral',
  className: '',
  children: /*#__PURE__*/React.createElement("div", null),
  dismissible: false,
  isActive: true,
  toggleExpand: false,
  onDismiss: function onDismiss() {},
  onToggle: function onToggle() {},
  size: 'md',
  title: null,
  inlineChildren: false,
  utils: {}
};
function switchIcon(variant, size, ariaLabelledby, ariaDescribedby) {
  var iconSize = 1.34;
  if (size === 'lg') {
    iconSize = 1.7;
  }
  switch (variant) {
    case 'critical':
      return /*#__PURE__*/React.createElement(Icon, {
        icon: "messagingCritical",
        size: iconSize,
        boxHeight: 4,
        color: "alert-red",
        alt: "Error",
        "aria-labelledby": ariaLabelledby,
        "aria-describedby": ariaDescribedby
      });
    case 'caution':
      return /*#__PURE__*/React.createElement(Icon, {
        icon: "messagingCaution",
        size: iconSize,
        boxHeight: 4,
        color: "alert-yellow",
        alt: "Caution flag",
        "aria-labelledby": ariaLabelledby,
        "aria-describedby": ariaDescribedby
      });
    case 'success':
      return /*#__PURE__*/React.createElement(Icon, {
        icon: "messagingSuccess",
        size: iconSize,
        boxHeight: 4,
        color: "alert-green",
        alt: "Checkmark",
        "aria-labelledby": ariaLabelledby,
        "aria-describedby": ariaDescribedby
      });
    case 'information':
      return /*#__PURE__*/React.createElement(Icon, {
        icon: "messagingInfo",
        size: iconSize,
        boxHeight: 4,
        color: "alert-blue",
        alt: "Info",
        "aria-labelledby": ariaLabelledby,
        "aria-describedby": ariaDescribedby
      });
    default:
      return /*#__PURE__*/React.createElement(Icon, {
        icon: "messagingInfo",
        size: iconSize,
        boxHeight: 4,
        color: "alert-gray",
        alt: "Info",
        "aria-labelledby": ariaLabelledby,
        "aria-describedby": ariaDescribedby
      });
  }
}

/**
 * @ignore @description
 * ## Alert Component
 * An alert displays a short, important message in a way that attracts the user's attention without interrupting the user's task.
 *
 * @ignore @see Mesh: [Alert Docs](https://mesh-component-library.apps.csts-k8cnp-ro-1.r-caas.allstate.com/?path=/story/informational-alert--default)
 *
 *  * @ignore @example
 * ```jsx
 * import { Alert } from 'mesh-component-library';
 *
 * <Alert {...props}>
 * <Alert.Body>message</Alert.Body>
 * </Alert>
 * ```
 */

export var Alert = function Alert(props) {
  var ariaLabelledby = props['aria-labelledby'],
    ariaDescribedby = props['aria-describedby'],
    variant = props.variant,
    children = props.children,
    className = props.className,
    dismissible = props.dismissible,
    isActive = props.isActive,
    onDismiss = props.onDismiss,
    onToggle = props.onToggle,
    alertMessages = props.alertMessages,
    toggleExpand = props.toggleExpand,
    size = props.size,
    title = props.title,
    inlineChildren = props.inlineChildren,
    utils = props.utils,
    other = _objectWithoutProperties(props, _excluded);
  var _useState = useState(isActive),
    _useState2 = _slicedToArray(_useState, 2),
    active = _useState2[0],
    setActive = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isExpanded = _useState4[0],
    setExpanded = _useState4[1];
  useEffect(function () {
    if (isActive != active) {
      setActive(isActive);
    }
  }, [isActive]);
  useEffect(function () {
    if (toggleExpand !== isExpanded) {
      setExpanded(toggleExpand);
    }
  }, [toggleExpand]);
  var dismissAlert = function dismissAlert(event) {
    setActive(false);
    onDismiss(event);
  };
  var toggleAlertBody = function toggleAlertBody(event) {
    setExpanded(!isExpanded);
    onToggle(event);
  };
  var filterMessages = function filterMessages(messages) {
    var filterAlertMessages = messages.filter(function (message, i) {
      return i < 3 ? message : null;
    });
    return mapMessages(filterAlertMessages);
  };
  var mapMessages = function mapMessages(messages) {
    return messages.map(function (mes, i) {
      var messageIndex = "message_".concat(i);
      return /*#__PURE__*/React.createElement(Type, {
        variant: "dark",
        element: "li",
        key: messageIndex
      }, mes);
    });
  };
  var icon = switchIcon(variant, size, ariaLabelledby, ariaDescribedby);
  var alert = /*#__PURE__*/React.createElement(StyledAlert, _extends({}, other, {
    variant: variant,
    dismissible: dismissible,
    role: "alert",
    className: className,
    size: size,
    utils: utils
  }), /*#__PURE__*/React.createElement(InverseContext.Provider, {
    value: false
  }, createDismissBtn(dismissible, dismissAlert), icon && /*#__PURE__*/React.createElement(StyledAlertIcon, null, icon), /*#__PURE__*/React.createElement(StyledAlertBodyWrapper, null, /*#__PURE__*/React.createElement(StyledAlertBody, {
    variant: variant
  }, title && /*#__PURE__*/React.createElement(Type, {
    element: "span",
    weight: "bold",
    variant: "dark"
  }, title), children && /*#__PURE__*/React.createElement(StyledAlertChildren, {
    inlineChildren: inlineChildren
  }, children), !!alertMessages.length && /*#__PURE__*/React.createElement(Type, {
    element: "ul",
    listStyle: "bulleted",
    utils: {
      hrLeft: 'md'
    }
  }, isExpanded ? mapMessages(alertMessages) : filterMessages(alertMessages))), alertMessages.length > 3 && /*#__PURE__*/React.createElement(StyledAlertButton, {
    variant: "phony",
    onClick: toggleAlertBody,
    utils: utils,
    "aria-label": "Dismiss Alert"
  }, isExpanded ? 'View Less' : 'View All'))));
  return /*#__PURE__*/React.createElement("div", null, active ? alert : null);
};
function createDismissBtn(dismissible, dismissAlert) {
  if (!dismissible) {
    return;
  }
  return /*#__PURE__*/React.createElement(StyledAlertBtnContainer, null, /*#__PURE__*/React.createElement(StyledAlertButton, {
    hasIconOnly: true,
    size: "xs",
    isHollow: true,
    onClick: dismissAlert,
    "aria-label": "Dismiss Alert"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "cross",
    color: "#222222",
    size: 1,
    alt: "Close"
  })));
}
Alert.propTypes = alertPropTypes;
Alert.defaultProps = alertDefaultProps;
Alert.displayName = 'Alert';
Alert.Body = AlertBody;
/**
 * @type React.FC<alertPropTypes>
 */
export default withDeprecatedProps(Alert);